export const ORG_METADATA_HIDE_DEFAULT_REFS_KEY = 'INVENTORY_HIDE_DEFAULT_REFS'
export const ORG_METADATA_ALLOW_REFS_CREATION_KEY = 'ALLOW_REFS_CREATION'
